import { checkForDuplicateGroups } from '@/redux/util';

export const removeGroups = (groupIDs, announcement) => {
	const groupsToRemove = groupIDs.map(group => group.id);
	const updatedGroups = announcement.groups.filter(group => !groupsToRemove.includes(group.id));
	return { ...announcement, groups: updatedGroups };
};

export const addGroups = (groupIDs, announcement) => {
	const newGroups = checkForDuplicateGroups(announcement.groups ?? [], groupIDs);
	return { ...announcement, groups: [...(announcement.groups ?? []), ...newGroups] };
};
